import React from "react";
import parse from "html-react-parser";
import { fetchDataList, fetchCompanyDataList } from "../../api";
import { useQuery } from "react-query";
import Image from "../Image/Image";
import BlogPostAdd from "../BlogPostAdd/BlogPostAdd";
import CodeEditor from "../CodeEditor/CodeEditor";
import BlogOverview from "../BlogOverview/BlogOverview";
import { GlobalContext } from "../../context/GlobalContext";

function BlogPostQuicklink({ ticker, meta, category }) {
  const { isMobile } = React.useContext(GlobalContext);

  const [pageNumber, setPageNumber] = React.useState(0);
  const limit = 6;

  const { data: companyArticle } = useQuery(
    ["companyblog", ticker, pageNumber, limit],
    () => fetchCompanyDataList("companyblog", ticker, pageNumber, limit)
  );

  const { data: imageSource } = useQuery(["general-libraryImage"], () =>
    fetchDataList("general")
  );

  const [showBlogAdditional, setShowBlogAdditional] = React.useState(false);

  return (
    <>
      <BlogPostAdd
        data={meta}
        visible={showBlogAdditional}
        setShowVisible={setShowBlogAdditional}
        category={category}
      />

      <div className="article-main">
        {isMobile && (
          <div className="article-image-wrapper">
            {imageSource?.libraryImage && (
              <Image
                height="200px"
                source={imageSource?.libraryImage}
                alternativetext="Library Image"
                className="article-main-image card-img-top"
              />
            )}
            <div className="article-image-filter-mobile">
              <div className="article-base-info-mobile">
                {meta?.logo && (
                  <a onClick={() => setShowBlogAdditional((prev) => !prev)}>
                    <Image
                      source={meta?.logo}
                      className="article-logo"
                      alternativetext={`${ticker} logo`}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="article-image-container">
            <div className="article-image-section">
              {imageSource?.libraryImage && (
                <>
                  <Image
                    height="420px"
                    source={imageSource?.libraryImage}
                    alternativetext="Library Image"
                    className="article-main-image card-img-top"
                  />
                  <div className="article-image-white-gradient-overlay" />
                </>
              )}
            </div>
            <div className="article-image-meta">
              <div>
                <div className="article-base-info">
                  <a onClick={() => setShowBlogAdditional((prev) => !prev)}>
                    {meta?.logo && (
                      <Image
                        source={meta?.logo}
                        className="article-logo"
                        alternativetext={`${ticker} logo`}
                      />
                    )}
                  </a>

                  <h4 className="text-dark text-muted text-truncate">
                    {meta?.name}
                  </h4>

                  <div
                    id="meta-description"
                    className={`text-muted text-justify article-base-description article-base-description-overflow`}
                  >
                    {meta?.description && parse(meta?.description)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="article-header-area text-center">
          <h1 className="text-light article-header">{meta?.name}</h1>
        </div>
        <br />
        <BlogOverview
          data={companyArticle}
          category={category}
          datalength={meta?.length}
          page={pageNumber}
          setPage={setPageNumber}
          limit={limit}
          title={meta?.name || ticker}
        />
      </div>
    </>
  );
}

export default BlogPostQuicklink;
